import React from 'react'
import {FocusTrap} from 'focus-trap-react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCheck, faUpRightFromSquare} from '@fortawesome/free-solid-svg-icons'
import SaveMoneyTime from '../../assets/save-moneytime-cabana.svg'

export interface ExtendedStayModalProps {
  isOpen: boolean
  onClose: () => void
}

const ExtendedStayModal = ({isOpen, onClose}: ExtendedStayModalProps) => {
  const features = [
    'Skip the application fees',
    'Settle into fully furnished spaces with kitchens, in-unit laundry, and walkable locations',
    'Enjoy on-site amenities like rooftop lounges, pools, gyms, and more',
    'Relax with weekly housekeeping on stays of 10+ days',
    'Count on 24/7 support from our Placemaker team'
  ]

  return (
    <>
      {isOpen && (
        <FocusTrap active={isOpen}>
          <div
            className="modal modal-open"
            onClick={e => {
              if (e.target === e.currentTarget) {
                onClose()
              }
            }}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-box p-0 max-w-screen-sm max-h-[95%]">
              <button
                className="btn btn-sm btn-circle btn-white absolute right-2 top-2"
                onClick={onClose}
                aria-label="Close unit details modal."
              >
                ✕
              </button>
              <div className="modal-body overflow-y-scroll pr-4 mt-2 px-8 py-4">
                <div className="flex flex-col gap-2">
                  <img
                    src={SaveMoneyTime}
                    alt="Save money time"
                    className="h-12 w-12"
                  />
                  <h1 className="text-xl font-semibold">
                    Stay Longer. Save More.
                  </h1>
                  <div className="text-sm font-medium">
                    Save 15% on 7+ night stays.
                    <br />
                    Save 30% on 28+ night stays.
                  </div>
                  <div className="flex flex-col gap-4 mt-4 mx-4">
                    {features.map((feature, index) => (
                      <div
                        key={index}
                        className="flex flex-row items-center justify-start gap-4"
                      >
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="text-accent text-lg"
                        />
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                  <div className="flex flex-row items-center justify-center mt-4">
                    <a
                      className="link link-accent text-sm mx-auto"
                      href="https://www.placemakr.com/faq#extended-stay-faqs"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>See Extended Stay FAQs for more info</span>
                      <FontAwesomeIcon
                        icon={faUpRightFromSquare}
                        className="ml-2"
                      />
                    </a>
                  </div>
                  <div className="flex flex-row items-center justify-center my-4">
                    <p className="text-xs text-gray-500">
                      Amenities and in-unit features vary by property
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FocusTrap>
      )}
    </>
  )
}

export default ExtendedStayModal
